import {appFetch, AppFetchResponse} from "../utils/appFetch";

export const getNextCyclePricingPlan = async (selectedDomain: string): Promise<AppFetchResponse> => {
    return appFetch({
        endpoint: `pricing-plans/next-cycle`,
        method: 'GET',
        headers: {
            "Content-Type": "application/json",
        },
        domain: selectedDomain,
        isEncrypted: true,
    });
}